import { FC, ReactNode } from 'react';

import { Box, HStack, InformationCircleOutline, Text, Tooltip } from '@bonusly/design-system';

interface PreferenceSettingRowProps {
	label: string;
	tooltip?: string;
	children: ReactNode;
}

export const PreferenceSettingRow: FC<PreferenceSettingRowProps> = ({ label, tooltip, children }) => (
	<Box borderBottom="1px solid" borderColor="border.soft" py={3}>
		<HStack align="center" justify="space-between" minH="10" spacing={4}>
			<Box>
				<HStack spacing={1.5}>
					<Text color="text.soft" size="sm" variant="medium">
						{label}
					</Text>
					{tooltip && (
						<Tooltip hasArrow={false} label={tooltip}>
							<Box alignItems="center" as="span" display="inline-flex">
								<InformationCircleOutline color="text.softest" size="xs" />
							</Box>
						</Tooltip>
					)}
				</HStack>
			</Box>
			{children}
		</HStack>
	</Box>
);
